"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var OrgEntitlementsTable = /*#__PURE__*/function () {
  OrgEntitlementsTable.$inject = ["$element", "$scope"];
  /* @ngInject */
  function OrgEntitlementsTable($element, $scope) {
    _classCallCheck(this, OrgEntitlementsTable);
    this.$scope = $scope;
  }

  /**
   * Builds the column titles based on the row keys on changes on the rows
   *
   * @param {Object} changes
   */
  return _createClass(OrgEntitlementsTable, [{
    key: "$onChanges",
    value: function $onChanges(changes) {
      if (changes.rows && changes.rows.currentValue) {
        this.columnTitles = changes.rows.currentValue.reduce(function (accumulator, row) {
          for (var _i = 0, _Object$keys = Object.keys(row); _i < _Object$keys.length; _i++) {
            var columnTitle = _Object$keys[_i];
            if (accumulator.indexOf(columnTitle) === -1 && columnTitle.indexOf('_') === -1) {
              accumulator.push(columnTitle);
            }
          }
          return accumulator;
        }, []);
      }
    }

    /**
     * Emits 'LOAD_PREVIOUS_TRANSACTION_PAGE' on previous page button click
     *
     */
  }, {
    key: "onPreviousPageButtonClick",
    value: function onPreviousPageButtonClick() {
      if (!this.hasPreviousPage) return;
      this.$scope.$emit('LOAD_PREVIOUS_TRANSACTION_PAGE', this.productName);
    }

    /**
     * Emits 'LOAD_NEXT_TRANSACTION_PAGE' on next page button click
     *
     */
  }, {
    key: "onNextPageButtonClick",
    value: function onNextPageButtonClick() {
      if (!this.hasNextPage) return;
      this.$scope.$emit('LOAD_NEXT_TRANSACTION_PAGE', this.productName);
    }
  }]);
}();
module.exports = angular.module('backstage.components.orgs.view-org.entitlements-manager.org-entitlements-table', ['backstage.services']).component('bsOrgEntitlementsTable', {
  templateUrl: '/src/angular/components/orgs/view-org/org-entitlements-manager/org-entitlements-table/org-entitlements-table.html',
  bindings: {
    rows: '<',
    loading: '<',
    emptyText: '@',
    productName: '@',
    hasNextPage: '<',
    hasPreviousPage: '<',
    organization: '<'
  },
  controllerAs: 'vm',
  controller: OrgEntitlementsTable
}).name;